import { render, staticRenderFns } from "./NotAnsweredPoolMessageNotificationListItem.vue?vue&type=template&id=334c7ecc&scoped=true&"
import script from "./NotAnsweredPoolMessageNotificationListItem.vue?vue&type=script&lang=ts&"
export * from "./NotAnsweredPoolMessageNotificationListItem.vue?vue&type=script&lang=ts&"
import style0 from "./NotAnsweredPoolMessageNotificationListItem.vue?vue&type=style&index=0&id=334c7ecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "334c7ecc",
  null
  
)

/* custom blocks */
import block0 from "./NotAnsweredPoolMessageNotificationListItem.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports